import { Navigate, Outlet } from "@tanstack/react-router";
import { AppShell } from "./components/app-shell";
import { useAuth } from "./lib/auth-context";

export function RootComponent() {
  return <Outlet />;
}

export function ProtectedLayout() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/" replace />;
  return <AppShell />;
}
